// extracted by mini-css-extract-plugin
export default {"toast-page-wrapper":"toast_toast-page-wrapper_lwomU","toast-page":"toast_toast-page_ycrkq","toast-icon":"toast_toast-icon_o1o7T","toast-text":"toast_toast-text_kB5JI"};